import http from "../http-common";

class GradeService {
  getAll() {
    return http.get("/grades");
  }

  get(id) {
    return http.get(`/grades/${id}`);
  }

  create(data) {
    return http.post("/grades", data);
  }

  update(id, data) {
    return http.put(`/grades/${id}`, data);
  }

  delete(id) {
    return http.delete(`/grades/${id}`);
  }

  getTrashed() {
    return http.get("/grades/trashed/list");
  }

  restore(id) {
    return http.post(`/grades/${id}/restore`);
  }
}

export default new GradeService();
